import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  padding: 30px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-size: 1.625rem;
  color: #074f8c;
  @media (max-width: 375px) {
    font-size: 1.4375rem;
  }
`;

export const BackButton = styled.span`
  font-size: 1.25rem;
  color: #074f8c;
  margin-right: 10px;
  margin-left: -3px;
  cursor: pointer;
  @media (max-width: 375px) {
    font-size: 1.125rem;
  }
`;

export const CloseIcon = styled.span`
  font-size: 1.25rem;
  margin-top: -50px;
  margin-right: -11px;
  color: #074f8c;
  cursor: pointer;
  @media (max-width: 370px) {
    font-size: 1.125rem;
  }
`;

export const Content = styled.span`
  font-size: 1rem;
  font-weight: 400;
  color: #808495;
  @media (max-width: 385px) {
    font-size: 0.875rem;
  }
`;

export const FieldsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 25px;
`;

export const Fields = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const FindYourCode = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
`;

export const FindYourCodeText = styled.span`
  font-size: 0.875rem;
  color: #074f8c;
  font-weight: 100;
`;

export const FindYourCodeIcon = styled.span`
  font-size: 1.25rem;
  color: #f0b01b;
  margin-left: 5px;
`;

export const PhonesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 200px;
  padding-left: 1.5px;
  margin-top: 25px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 15px;
`;

export const Button = styled.div`
  width: 75%;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const PhoneSelect = styled.div`
  margin-bottom: 10px;
`;

export const PhoneInput = styled.input`
  margin-right: 10px;
`;

export const PhoneLabel = styled.label``;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -50px;
`;

export const SuccessIconContainer = styled.div`
  width: 73px;
  height: 73px;
  border-radius: 36.5px;
  background-color: #e5ffe8;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SuccessIcon = styled.span`
  font-size: 3.4375rem;
  margin-top: 5.5px;
  color: #75b943;
`;

export const SuccessTitle = styled.span`
  font-size: 1.5625rem;
  text-align: center;
  color: #074f8c;
  margin-top: 20px;
  @media (max-width: 370px) {
    font-size: 1.4375rem;
  }
`;

export const SuccessText = styled.span`
  color: #808495;
  text-align: center;
  margin-top: 15px;
  font-size: 1rem;
  padding: 0px 30px 0px 30px;
  @media (max-width: 370px) {
    font-size: 0.9375rem;
    padding: 0;
  }
`;

export const SuccessProtocol = styled.span`
  color: #f0b01b;
  text-align: center;
  margin-top: 15px;
  font-size: 1rem;
  @media (max-width: 370px) {
    font-size: 0.9375rem;
  }
`;

export const ErrorIconContainer = styled.div`
  width: 73px;
  height: 73px;
  border-radius: 36.5px;
  background-color: #fff4e5;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ErrorIcon = styled.span`
  font-size: 3.4375rem;
  margin-top: 5.5px;
  color: #fdc43c;
`;

export const UacContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin-top: 20px;
  @media (max-width: 350px) {
    flex-direction: column;
  }
`;

export const UacItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const UacDescription = styled.span`
  font-size: 0.9375rem;
  color: #074f8c;
  text-align: center;
`;

export const UacPhone = styled.span`
  font-size: 0.875rem;
  color: #9fa2af;
`;

export const WithoutInvoicesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: -12px;
`;

export const WithoutInvoices = styled.span`
  font-weight: bold;
  color: #074f8c;
  font-size: 1.125rem;
  text-decoration: underline #074f8c;
  cursor: pointer;
`;

export const ModalCodeHeader = styled(Modal.Header)`
  background-color: #074f8c;
`;

export const ModalCodeTitle = styled(Modal.Title)`
  color: #ffffff;
`;

export const ModalCodeBody = styled(Modal.Body)`
  color: #ffffff;
`;

export const ModalCodeContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const ModalCodeImageContainer = styled.div`
  cursor: pointer;
  width: 100%;
`;

export const ModalCodeImage = styled.img`
  width: 100%;
`;

export const ModalCodeSection = styled.div``;

export const ModalCodeItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const ModalCodeItemImage = styled.div`
  width: 45%;
  cursor: pointer;
`;

export const ViewMoreText = styled.span`
  cursor: pointer;
`;

export const OpeningHoursContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`;

export const OpeningHours = styled.span`
  color: #808495;
  text-align: center;
  font-size: 1rem;
  padding: 0px 30px 0px 30px;
  @media (max-width: 370px) {
    font-size: 0.9375rem;
    padding: 0;
  }
`;
